import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const GPOA = () => {
  const faqs = [
    {
      question: "Q: What is the “POA” feature used for ?",
      answer:
        "A: The “POA” feature allows users to generate Power of Attorney forms quickly and efficiently. It supports batch preparation for up to 500 application numbers, helping attorneys and paralegals save time and reduce manual effort.",
    },
    {
      question: "Q: What inputs are required for generating POA forms ?",
      answer:
        "A: You will need the application number(s), attorney name, and registration number, plus responses to system prompts for signature and 37 CFR. If 37 CFR is selected, the downloaded PDF will contain a merged sequence: POA, GPOA (if provided), and 37 CFR.",
    },
    {
      question: "Q: In which format are the forms downloaded ?",
      answer:
        "A: All POA forms are downloaded in PDF format. These can be edited using any PDF editor installed on your system.",
    },
    {
      question: "Q: Where can I download the generated POA forms ?",
      answer:
        "A: Once processing is complete, the PDF forms can be downloaded directly from the JUNE interface. For larger requests, you’ll also receive an email notification with a download link once the forms are ready.",
    },
    {
      question: "Q: How does the GPOA option work while generating POA forms ?",
      answer:
        "A: You can upload a GPOA while generating a POA, and it will be merged with the POA for all application numbers in the request. If you prefer, you may skip uploading a GPOA and generate POA forms without it.",
    },
    {
      question: "Q: Can POA and 37 CFR be merged for an application number ?",
      answer:
        "A: Yes. When generating either form, JUNE prompts you to include the other. If selected, both documents are generated together in a single PD.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default GPOA;
